// extracted by mini-css-extract-plugin
export var fixedHeader = "header-module--fixedHeader--0T9n8";
export var headerNoImg = "header-module--headerNoImg--sJmlJ";
export var image = "header-module--image--6kMYR";
export var link = "header-module--link--muri5";
export var linkContainer = "header-module--linkContainer--sgdtv";
export var noFeaturedImage = "header-module--noFeaturedImage--pBXU4";
export var slider = "header-module--slider--0nI5s";
export var togglerContainer = "header-module--togglerContainer--POn2K";